import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { c } from "@/theme/colorUtils";

function isValidProfileRegistrationPromptState(state) {
  return (
    state &&
    typeof state === "object" &&
    state.returnToPokoroSettingAfterProfile === true
  );
}

function ProfileRegistrationPrompt(props) {
  const { intl } = props;
  const history = useHistory();
  const location = useLocation();
  const [uiReady, setUiReady] = React.useState(false);

  useEffect(() => {
    if (!isValidProfileRegistrationPromptState(location.state)) {
      history.replace("/home");
      return;
    }
    setUiReady(true);
  }, [history, location.state]);

  const handleSetupNow = () => {
    const s = location.state || {};
    history.push("/signin/nickname", {
      notNewUser: s.notNewUser,
      redirectUrl: s.redirectUrl,
      deviceId: s.deviceId,
      showBackButton: s.showBackButton,
      returnToPokoroSettingAfterProfile: s.returnToPokoroSettingAfterProfile,
    });
  };

  // 유효하지 않은 진입(WebView 히스토리 복원 등)에서는 오버레이를 그리지 않음 — 전체 화면이 먹통되는 것 방지
  if (!uiReady) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: (theme) => theme.zIndex.modal,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 328,
          bgcolor: "#fff",
          borderRadius: "20px",
          px: 3,
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            textAlign: "center",
            width: "100%",
            color: "#333",
          }}
        >
          <Typography
            component="div"
            sx={{
              fontWeight: 700,
              fontSize: 18,
              lineHeight: 1.4,
              whiteSpace: "pre-line",
            }}
          >
            {intl.formatMessage({ id: "profile_registration_prompt_title" })} 
          </Typography>
          <Typography
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 1.4,
              whiteSpace: "pre-line",
            }}
          >
            {intl.formatMessage({ id: "profile_registration_prompt_description" })}
          </Typography>
        </Box>
        <Button
          fullWidth
          disableRipple
          onClick={handleSetupNow}
          sx={{
            minHeight: 52,
            py: 2,
            px: 2,
            borderRadius: "8px",
            bgcolor: c.primary,
            border: `2px solid ${c.primary}`,
            color: c.text01,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.4,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              bgcolor: c.primary,
              borderColor: c.primary,
              boxShadow: "none",
            },
          }}
        >
          {intl.formatMessage({ id: "profile_registration_prompt_cta" })}
        </Button>
      </Box>
    </Box>
  );
}

export default injectIntl(observer(ProfileRegistrationPrompt));
